import { render, staticRenderFns } from "./dosage-form.vue?vue&type=template&id=e1247b14"
import script from "./dosage-form.vue?vue&type=script&lang=js"
export * from "./dosage-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports